import React from 'react'
import { useContextSelector } from 'use-context-selector'

import { FormContext } from 'components/formKit/Form'
import type { IButtonPropsType } from 'components/uiKit/Button'
import Button from 'components/uiKit/Button'
import { t } from 'services/Translation'

interface IFormButtonCancelProps extends Omit<IButtonPropsType, 'children' | 'name'> {
  label?: string
}

const FormButtonCancel: React.FC<IFormButtonCancelProps> = ({
  onClick,
  label,
  styleType = 'ghost',
  ...rest
}) => {
  const onReset = useContextSelector(FormContext, (state) => state.resetFields)

  return (
    <Button {...rest} name='cancel' onClick={onClick || onReset} styleType={styleType}>
      {label || t('uiKit.button.cancel')}
    </Button>
  )
}

export default FormButtonCancel
